import { render } from "./neworder.vue?vue&type=template&id=18b22f2e"
import script from "./neworder.vue?vue&type=script&lang=js"
export * from "./neworder.vue?vue&type=script&lang=js"

import "./neworder.vue?vue&type=style&index=0&id=18b22f2e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__